
export function getDataTimeString(now = new Date()) {
  const day = ('0' + now.getDate()).slice(-2);
  const month = ('0' + (now.getMonth() + 1)).slice(-2);
  const minutes = ('0' + (now.getMinutes())).slice(-2);
  const currentDate = now.getFullYear() + '-' + (month) + '-' + (day) + ' ' + now.getHours() + ':' + minutes;

  return currentDate;
}



// WEBPACK FOOTER //
// ./src/app/libs/Util.js